import PropTypes from 'prop-types';
import React from 'react';

import Button from 'gd-comp-button';

import Classes from 'classnames';

class ModalActionsStartEnd extends React.Component {
    static propTypes = {
        options: PropTypes.array.isRequired, // [{value:'', label:'', description:''}]
        defaultValue: PropTypes.string.isRequired,
        onSubmit: PropTypes.func.isRequired,
    };

    state = {
        selectedOption: this.props.defaultValue
    };

    onOptionClick = (value) => {
        this.setState({
            selectedOption: value
        })
    };

    onExport = () => {
        this.props.onSubmit({
            selectedOption: this.state.selectedOption
        });
    };

    render() {
        const { options } = this.props;
        const { selectedOption } = this.state;

        return (
            <div className="gd-form-modal-new">
                <div className="tbl">
                    {options.map(opt => {
                        const optClasses = Classes('export-option', {
                            'is-selected': selectedOption === opt.value
                        });
                        return (
                            <div className="row" key={opt.value}>
                                <div className="label"/>
                                <div className="element">
                                    <div className={optClasses} onClick={this.onOptionClick.bind(this, opt.value)}>
                                        <div className={Classes("option-icon", "ui5-radio", "s-13", {selected: selectedOption === opt.value})}/>
                                        <div className="option-label">{opt.label}</div>
                                        <div className="option-description">{opt.description}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="actions">
                    <Button className="submit" type="primary" label="Export" onClick={this.onExport} />
                </div>
            </div>
        );
    }
}

module.exports = ModalActionsStartEnd;